import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import { FaStar, FaEdit, FaRegStar } from "react-icons/fa";
import "assets/theme/admin_list.css";

const CoreValuesList = () => {
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchValues = async () => {
    try {
      const res = await apiFetch("leader_admin/get_core_values");
      setValues(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchValues();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaStar />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  मूलभूत मूल्ये व्यवस्थापन / Core Values Management
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  मूलभूत मूल्ये कार्ड व्यवस्थापन
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : values.length === 0 ? (
              <div className="text-center py-5">
                <FaRegStar className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">कोणतीही नोंद उपलब्ध नाही</h6>
                <p className="text-muted small mb-0">No core values have been added yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>शीर्षक (Title)</th>
                      <th>वर्णन (Description)</th>
                      <th style={{ width: "90px" }}>क्रम (Order)</th>
                      <th className="text-center" style={{ width: "120px" }}>क्रिया (Action)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values
                      .sort((a, b) => a.display_order - b.display_order)
                      .map((item, index) => (
                        <tr key={item.id}>
                          <td>
                            <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                          </td>

                          <td className="fw-bold text-dark">{item.title}</td>

                          <td style={{ maxWidth: "350px" }}>
                            <div className="small text-muted text-truncate">
                              {item.description}
                            </div>
                          </td>

                          <td>
                            <span className="badge bg-secondary bg-opacity-10 text-secondary fw-bold px-3 py-1 rounded-pill">
                              #{item.display_order}
                            </span>
                          </td>

                          <td>
                            <div className="d-flex justify-content-center gap-2">
                              <Link
                                to={`/edit_core_value/${item.id}`}
                                className="btn-action-icon edit"
                                title="संपादन"
                              >
                                <FaEdit />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CoreValuesList;